import type { MenuProps } from 'antd';
import React from 'react';

import {
	ApiOutlined,
	AppstoreAddOutlined,
	AudioOutlined,
	BarChartOutlined,
	BellOutlined,
	CompassOutlined,
	CustomerServiceOutlined,
	DollarOutlined,
	FileDoneOutlined,
	FileTextOutlined,
	InboxOutlined,
	KeyOutlined,
	MessageOutlined,
	PhoneOutlined,
	PieChartOutlined,
	SettingOutlined,
	SoundOutlined,
	UserOutlined,
	WechatWorkFilled,
	CalendarOutlined,
	FormOutlined,
	GiftOutlined,
} from '@ant-design/icons';

import { ReceptionistDashboardSiderItem } from './EReceptionistDashboardSiderItem';
import { Rocket } from 'lucide-react';

// Define the type for menu items
type MenuItem = Required<MenuProps>['items'][number];

// Export the items array
export const sidebarItems: MenuItem[] = [
	{
		key: ReceptionistDashboardSiderItem.GET_STARTED,
		icon: React.createElement(Rocket),
		label: ReceptionistDashboardSiderItem.GET_STARTED,
	},
	{
		key: ReceptionistDashboardSiderItem.HIRE_AI_RECEPTIONIST,
		icon: React.createElement(PhoneOutlined),
		label: ReceptionistDashboardSiderItem.HIRE_AI_RECEPTIONIST,
	},
	{
		key: ReceptionistDashboardSiderItem.RECEPTIONIST,
		icon: React.createElement(AppstoreAddOutlined),
		label: ReceptionistDashboardSiderItem.RECEPTIONIST,
	},
	{
		key: ReceptionistDashboardSiderItem.CELLO_REFERRAL,
		icon: React.createElement(GiftOutlined),
		label: ReceptionistDashboardSiderItem.CELLO_REFERRAL,
	},
	{
		key: ReceptionistDashboardSiderItem.CRM,
		icon: React.createElement(BarChartOutlined),
		label: ReceptionistDashboardSiderItem.CRM,
	},
	{
		key: ReceptionistDashboardSiderItem.ALL_LOGS,
		icon: React.createElement(InboxOutlined),
		label: ReceptionistDashboardSiderItem.ALL_LOGS,
	},
	{
		key: ReceptionistDashboardSiderItem.EMBEDDABLES,
		icon: React.createElement(ApiOutlined),
		label: ReceptionistDashboardSiderItem.EMBEDDABLES,
	},
	{
		key: ReceptionistDashboardSiderItem.VOICE_LIBRARY,
		icon: React.createElement(SoundOutlined),
		label: ReceptionistDashboardSiderItem.VOICE_LIBRARY,
	},
	{
		key: ReceptionistDashboardSiderItem.CALENDAR,
		icon: React.createElement(CalendarOutlined),
		label: ReceptionistDashboardSiderItem.CALENDAR,
	},
	{
		key: ReceptionistDashboardSiderItem.TICKETS,
		icon: React.createElement(FormOutlined),
		label: ReceptionistDashboardSiderItem.TICKETS,
	},
	{
		key: ReceptionistDashboardSiderItem.TEST_CALL,
		icon: React.createElement(AudioOutlined),
		label: ReceptionistDashboardSiderItem.TEST_CALL,
	},
	{
		key: ReceptionistDashboardSiderItem.LOGS,
		icon: React.createElement(FileTextOutlined),
		label: ReceptionistDashboardSiderItem.LOGS,
		className: 'no-indent',
		children: [
			{
				key: ReceptionistDashboardSiderItem.CALL_LOGS,
				icon: React.createElement(PhoneOutlined),
				label: ReceptionistDashboardSiderItem.CALL_LOGS,
			},
			{
				key: ReceptionistDashboardSiderItem.TEXT_LOGS,
				icon: React.createElement(WechatWorkFilled),
				label: ReceptionistDashboardSiderItem.TEXT_LOGS,
			},
			{
				key: ReceptionistDashboardSiderItem.VOICE_MAIL_LOGS,
				icon: React.createElement(SoundOutlined),
				label: ReceptionistDashboardSiderItem.VOICE_MAIL_LOGS,
			},
			{
				key: ReceptionistDashboardSiderItem.INTAKE_FORMS,
				icon: React.createElement(FileDoneOutlined),
				label: ReceptionistDashboardSiderItem.INTAKE_FORMS,
			},
		],
	},

	{
		key: ReceptionistDashboardSiderItem.ANALYTICS,
		icon: React.createElement(PieChartOutlined),
		label: ReceptionistDashboardSiderItem.ANALYTICS,
	},
	{
		key: ReceptionistDashboardSiderItem.NOTIFICATIONS,
		icon: React.createElement(BellOutlined),
		label: ReceptionistDashboardSiderItem.NOTIFICATIONS,
	},
	{
		key: ReceptionistDashboardSiderItem.TEXTING_AGENT,
		icon: React.createElement(MessageOutlined),
		label: ReceptionistDashboardSiderItem.TEXTING_AGENT,
	},
	{
		key: ReceptionistDashboardSiderItem.EXPLORE_FEATURES,
		icon: React.createElement(CompassOutlined),
		label: ReceptionistDashboardSiderItem.EXPLORE_FEATURES,
	},
	{
		key: ReceptionistDashboardSiderItem.CONTACT_SUPPORT,
		icon: React.createElement(CustomerServiceOutlined),
		label: ReceptionistDashboardSiderItem.CONTACT_SUPPORT,
	},
	{
		key: ReceptionistDashboardSiderItem.ACCOUNT,
		icon: React.createElement(UserOutlined),
		label: ReceptionistDashboardSiderItem.ACCOUNT,
		children: [
			{
				key: ReceptionistDashboardSiderItem.SETTINGS,
				icon: React.createElement(SettingOutlined),
				label: ReceptionistDashboardSiderItem.SETTINGS,
			},
			{
				key: ReceptionistDashboardSiderItem.PASSWORD,
				icon: React.createElement(KeyOutlined),
				label: ReceptionistDashboardSiderItem.PASSWORD,
			},
			{
				key: ReceptionistDashboardSiderItem.CREDITS,
				icon: React.createElement(DollarOutlined),
				label: ReceptionistDashboardSiderItem.CREDITS,
			},
		],
	},
];

// Helper function to get filtered items
export const getFilteredItems = (): MenuItem[] => {
	return sidebarItems.filter(
		(item) =>
			item?.key !== ReceptionistDashboardSiderItem.CONTACT_SUPPORT &&
			item?.key !== ReceptionistDashboardSiderItem.EXPLORE_FEATURES,
	);
};
